import { generatePath } from "react-router";

import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

import { DesignSnackEditCreateNewItemContainer } from "@/components/features/snack/snack/create-new-item";

import { useGetParams } from "./hooks/use-get-params";

export const DesignSnackCreateNewItemPage = () => {
	const { hotelID, duplicateItemID } = useGetParams();

	return (
		<PageMeta title="スナックの作成" url={generatePath(PATHS.HOTEL.RESERVATION_PAGE.SNACK.EDIT.NEW, { hotelID })}>
			<DesignSnackEditCreateNewItemContainer hotelID={hotelID} duplicateItemID={duplicateItemID} />
		</PageMeta>
	);
};

DesignSnackCreateNewItemPage.displayName = "DesignSnackCreateNewItemPage";
